import * as THREE from 'three'
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'

const objLoader = new OBJLoader()
const stlExporter = new STLExporter()

/**
 * Load a Wavefront OBJ file and return its STL representation as a string.
 * @param {string} objSrc
 * @returns {Promise<string>} srlSrc
 */
export const objToStl = (objSrc) => {
	return new Promise((resolve, reject) => {
		objLoader.load(

			// urL:
			objSrc,

			// onLoad:
			loadedObject => {

				// Traverse the OBJ's children and get the mesh (ignore other possible objects, like lights):

				/** @type {THREE.Mesh} */
				let meshFound = null
				let meshesFoundQuantity = 0

				loadedObject.traverse(child => {
					if (child instanceof THREE.Mesh) {
						meshFound = child
						meshesFoundQuantity++
					}
				})

				// Control error cases:

				if (meshesFoundQuantity > 1) return reject(new Error('Multiple meshes found in Wavefront OBJ file'))
				if (meshFound == null) return reject(new Error('No mesh found in Wavefront OBJ file'))
				if (!meshFound.geometry?.isBufferGeometry) return reject(new Error('Mesh geometry is not BufferGeometry'))

				// Export the mesh found into an STL file:

				const stlContent = stlExporter.parse(meshFound)

				// Return the STL content as a string; the caller wraps it in a File.
				resolve(stlContent)
			},

			// onProgress:
			undefined,

			// onError:
			error => reject(error),
		)
	})
}
